import axios from 'axios'


export const http = axios.create({
    baseURL: process.env.VUE_APP_SERVICE_URL
})

http.interceptors.request.use((config) => {
    // Loga o baseURL quando o front faz uma chamada ao backend.
    const baseUrl = config.baseURL || process.env.VUE_APP_SERVICE_URL
    console.log('[API] baseURL:', baseUrl)
    return config
})
